import { render, staticRenderFns } from "./DicaPosicionamentoAssinatura.vue?vue&type=template&id=214cdbae"
import script from "./DicaPosicionamentoAssinatura.vue?vue&type=script&lang=js"
export * from "./DicaPosicionamentoAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports